import * as React from 'react';

const DasLocateOffWorkSvgColor = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 26H5V24H27V26ZM25 23H7V16H25V23ZM10.5 21C10.2239 21 10 21.2239 10 21.5C10 21.7761 10.2239 22 10.5 22C10.7761 22 11 21.7761 11 21.5C11 21.2239 10.7761 21 10.5 21ZM13.5 21C13.2239 21 13 21.2239 13 21.5C13 21.7761 13.2239 22 13.5 22C13.7761 22 14 21.7761 14 21.5C14 21.2239 13.7761 21 13.5 21ZM16.5 21C16.2239 21 16 21.2239 16 21.5C16 21.7761 16.2239 22 16.5 22H18.5C18.7761 22 19 21.7761 19 21.5C19 21.2239 18.7761 21 18.5 21H16.5ZM21.5 21C21.2239 21 21 21.2239 21 21.5C21 21.7761 21.2239 22 21.5 22C21.7761 22 22 21.7761 22 21.5C22 21.2239 21.7761 21 21.5 21ZM12 12V15H10V12L10.5 6H11.5L12 12ZM22 12V15H20V12L20.5 6H21.5L22 12Z"
      fill="#A1A1A1"
    />
    <circle cx="6" cy="26" r="6" fill="#E6A600" />
    <path
      d="M7.46582 29H2.75C2.33579 29 2 28.6642 2 28.25V25.2666L7.46582 29ZM7.25 22C7.66421 22 8 22.3358 8 22.75V24H9.25C9.66421 24 10 24.3358 10 24.75V28.25C10 28.603 9.75527 28.8958 9.42676 28.9756L2.3291 24.1289C2.44909 24.0474 2.59404 24 2.75 24H4V22.75C4 22.3358 4.33579 22 4.75 22H7.25ZM5 24H7V23H5V24Z"
      fill="white"
    />
    <path
      d="M9.5 28.5L2 23.5"
      stroke="white"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
  </svg>
);

export default DasLocateOffWorkSvgColor;
